const ACCORDION_VARIANTS = {
    DEFAULT: 'default',
    MINIMAL: 'minimal',
    BLUEBERRY: 'blueberry',
};

export default ACCORDION_VARIANTS;
